import CityPageTemplate from "../city-template/CityPageTemplate";
import { santaClaraConfig } from "./data";

export default function SantaClaraPage() {
  return <CityPageTemplate config={santaClaraConfig} />;
}